import React from 'react';

// Only display persisted closure identity; never infer it from execution pipeline,
// timestamps, inputs, or the Batch's currently open cycle.
export function PreparationIdentity({ identity }) {
  const pipeline = identity?.preparation_pipeline;
  const cycle = identity?.preparation_cycle_number;
  const known = ['size', 'encapsulation'].includes(pipeline) && Number.isInteger(cycle) && cycle > 0;
  return <span>{known ? `${pipeline === 'size' ? 'Size' : 'Encapsulation'} · Cycle ${cycle}` : 'Historical / unclassified cycle'}</span>;
}
